import { Col, Container, Row } from "react-bootstrap";
import { useGetCmsDetailQuery } from "store/services/cms";
import LoadingIndicator from "components/shared/LoadingIndicator";
import parse from "html-react-parser"
import { POLICY_AND_PROCEDURE } from "config/paths";
import { Link } from "react-router-dom";

const PolicyAndProceduresPreview = () => {

  const contentId = 17;
  const { data, isLoading, isFetching } = useGetCmsDetailQuery(contentId);

  const handleViewPdf = async (url) => {

    try {

      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };

  return (
    <>
      <section className="client position-relative py-4">
        <Container fluid>
          <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
            <div className="left">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to={POLICY_AND_PROCEDURE}
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">Policy & Procedures</h6>
              </div>
            </div>
          </div>
          {isLoading || isFetching ? <LoadingIndicator /> : <Row>

            <Col lg="12" className="my-3">

              <h3 className="fw-bold">{data?.title || ""}</h3>

              {data?.cover_img && <img style={{ width: "100%", height: "400px", objectFit: "fill" }} src={data?.cover_img} />}
              <div
                className="w-100 my-3"
              >
                {parse(data?.description || "")}
              </div>
            </Col>

            <Col lg="12" className="my-3">

              <div style={{ background: "#f3f3f3", fontSize: "14px" }} className="w-100 d-flex justify-content-center align-items-center py-2 fw-bold">
                Policy Procedures
              </div>
              <Row className="mt-3">
                <Col md="2" sm="12">
                  <h6 className="fw-bold">Title</h6>
                </Col>

                <Col md="8" sm="12">
                  <h6 className="fw-bold">Description</h6>

                </Col>

                <Col md="2" sm="12">
                  <h6 className="fw-bold w-100 d-flex justify-content-center">View</h6>

                </Col>

              </Row>
              {
                data?.documents?.map((item, index) => {

                  return <Row className="mt-3">
                    <Col md="2" sm="12">
                      <h6 className="fw-bold text-muted">{item?.title}</h6>
                    </Col>

                    <Col md="8" sm="12">
                      <p>{item?.description}</p>
                    </Col>

                    <Col md="2" sm="12">
                      <div className="w-100 d-flex justify-content-center">
                        <svg
                          onClick={() => handleViewPdf(item?.attachment?.attachment_key)}
                          style={{ cursor: "pointer" }}
                          xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                          <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                        </svg>
                      </div>
                    </Col>

                  </Row>
                })
              }

            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default PolicyAndProceduresPreview;
